const menu = {
    icon: 'pi pi-phone',
    label: 'Chamados',
    rules: ['SOL-001'],
    items: [
        {
            icon: 'pi pi-phone',
            label: 'Atendimento',
            to: '/sol/atendimentoChamado',
            rules: ['SOL-001'],
        },
        {
            icon: 'pi pi-file-excel',
            label: 'Relatórios',
            to: '/sol/relatorioChamados',
            rules: ['SOL-001'],
        },
    ],
};

export default menu;
